import * as React from "react";
import { useQuery } from "react-query";
import { useApiService, useTl } from "../../hooks";
import { RequestApi } from "../../api";
import { SmallFormGenerator } from "../SmallFormGenerator";
import { validate } from "uuid";
import * as Yup from "yup";
import { ETLCodes } from "../../locales";
import { ButtonContainer, FGTextAreaInput, FieldSet, showError } from "nsitools-react";
import { Button, Card } from "@blueprintjs/core";
import { ButtonsBloc, InlineButtonContainer } from "../applicationButtons/ButtonContainerStyles";

export interface IRequestCancelCommentDialogProps {
  requestId: number;
  onClose: (hasSaved: boolean) => void;
}

export const RequestCancelCommentDialog: React.FunctionComponent<IRequestCancelCommentDialogProps> = ({
  requestId,
  onClose,
}) => {
  const { t } = useTl();
  const requestApi = useApiService(RequestApi);
  const { data: comment, isFetching: loadingComment } = useQuery(
    ["request-comment", requestId],
    React.useCallback(async () => await requestApi.getRequestRemark(requestId), [requestApi, requestId])
  );

  const validationSchema = React.useMemo(() => {
    return Yup.object().shape({
      comment: Yup.string().nullable().required(t(ETLCodes.Required)),
    });
  }, [t]);

  const [saving, setsaving] = React.useState(false);
  const save = React.useCallback(async (d) => {
    setsaving(true);
    try {
      await requestApi.saveRequestComment(requestId, d.comment);
      await onClose(true);
    } catch {
      showError(t(ETLCodes.Error));
    } finally {
      setsaving(false);
    }
  }, []);

  return (
    <Card>
      <SmallFormGenerator
        initialValues={{ comment: comment?.value }}
        editMode={true}
        onSubmit={save}
        loading={loadingComment}
        saving={saving}
        validationSchema={validationSchema}
        hideButtons
      >
        <FieldSet title={t(ETLCodes.PleaseExplainReason)}>
          <FGTextAreaInput name="comment" label={t(ETLCodes.Remark)} />
          <InlineButtonContainer>
            <div />
            <ButtonsBloc>
              <Button intent="none" text={t(ETLCodes.General_GoBack)} icon="reset" onClick={() => onClose(false)} />{" "}
              <Button
                intent="primary"
                text={t(ETLCodes.ConfirmChange)}
                type="submit"
                icon={"floppy-disk"}
                loading={saving}
              />{" "}
            </ButtonsBloc>
          </InlineButtonContainer>
        </FieldSet>
      </SmallFormGenerator>
    </Card>
  );
};
